
import { useEffect, useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const featuredReviews = [
  {
    name: 'Kathy Bouwkamp',
    rating: 5,
    date: 'November 2024',
    text: 'Karen is a true professional. She is very knowledgeable and has great ideas. She is very easy to work with and listens to what you want. She is very responsive and always available to answer questions. I would highly recommend her to anyone looking for an interior designer.',
    project: 'Full-Service Design',
  },
  {
    name: 'Private User',
    rating: 5,
    date: 'October 2024',
    text: 'Karen was wonderful to work with. She listened to what we wanted and helped us achieve our vision. She was very responsive and professional throughout the entire process. We are thrilled with the results and would highly recommend her services.',
    project: 'Lakefront Home',
  },
  {
    name: 'James Wilson',
    rating: 5,
    date: 'February 2024',
    text: 'Karen helped us design our Saint Thomas residence and we are absolutely thrilled with the outcome. She understood the unique challenges of island living and created a space that is both elegant and practical. Highly recommend her services!',
    project: 'Saint Thomas Residence',
  },
];

const allReviews = [
  {
    name: 'Jennifer Smith',
    rating: 5,
    date: 'September 2024',
    text: 'Working with Karen was an absolute pleasure. Her attention to detail and creative vision transformed our space beyond our expectations. She managed every aspect of the project seamlessly and kept us informed throughout. Highly recommend K LINN Interiors!',
  },
  {
    name: 'Michael Thompson',
    rating: 5,
    date: 'August 2024',
    text: 'Karen has an incredible eye for design and a talent for understanding exactly what her clients need. She helped us create a home that is both beautiful and functional. Her professionalism and expertise made the entire process enjoyable.',
  },
  {
    name: 'Sarah Williams',
    rating: 5,
    date: 'July 2024',
    text: "We hired Karen for our lakefront home renovation and couldn't be happier with the results. She brought fresh ideas while respecting our style preferences. Her communication was excellent and she stayed within our budget. Truly a five-star experience.",
  },
  {
    name: 'David Anderson',
    rating: 5,
    date: 'June 2024',
    text: "Karen's design expertise is exceptional. She transformed our dated interior into a modern, sophisticated space that feels like home. Her ability to source unique pieces and coordinate with contractors made the process stress-free.",
  },
  {
    name: 'Lisa Martinez',
    rating: 5,
    date: 'May 2024',
    text: 'From our first consultation to the final reveal, Karen exceeded our expectations. She listened carefully to our needs and delivered a design that perfectly reflects our lifestyle. Her professionalism and creativity are unmatched.',
  },
  {
    name: 'Robert Johnson',
    rating: 5,
    date: 'April 2024',
    text: 'Karen designed our commercial office space and the results are stunning. She created an environment that is both professional and welcoming. Her attention to detail and project management skills are outstanding. Would definitely work with her again.',
  },
  {
    name: 'Emily Davis',
    rating: 5,
    date: 'March 2024',
    text: "Working with K LINN Interiors was the best decision we made for our home renovation. Karen's design sense is impeccable and she made the entire process enjoyable. She truly cares about her clients and it shows in her work.",
  },
  {
    name: 'Amanda Brown',
    rating: 5,
    date: 'January 2024',
    text: 'Karen is a talented designer with a gift for creating beautiful, livable spaces. She was patient with our indecision and guided us through every choice. The final result is a home we love and are proud to show off.',
  },
  {
    name: 'Christopher Lee',
    rating: 5,
    date: 'December 2023',
    text: 'We engaged Karen for a full home redesign and she delivered beyond our expectations. Her ability to blend our existing pieces with new selections created a cohesive, sophisticated look. Professional, creative, and a pleasure to work with.',
  },
  {
    name: 'Patricia Moore',
    rating: 5,
    date: 'November 2023',
    text: 'Karen transformed our outdated kitchen and living area into a stunning, cohesive space. Her material selections were impeccable and her project management kept everything on schedule. We receive compliments every time someone visits.',
  },
  {
    name: 'Thomas Harris',
    rating: 5,
    date: 'October 2023',
    text: 'Exceptional service from start to finish. Karen took the time to truly understand our vision and delivered results that exceeded what we imagined. Her expertise in art curation added a layer of sophistication we never expected.',
  },
  {
    name: 'Nancy Clark',
    rating: 5,
    date: 'September 2023',
    text: "Karen's window treatment designs completely changed the feel of our home. The custom drapery she specified is absolutely gorgeous and the quality is outstanding. She has a true gift for the finishing details that elevate a space.",
  },
];

const projectImages = [
  {
    src: 'https://st.hzcdn.com/fimgs/1f319fb8044197b4_9586-w800-h600-b0-p0---bathroom.jpg',
    label: 'Saint Thomas Master Bath',
  },
  {
    src: 'https://st.hzcdn.com/fimgs/9e21b34c04419801_9830-w800-h600-b0-p0---pool.jpg',
    label: 'Saint Thomas Infinity Pool',
  },
  {
    src: 'https://st.hzcdn.com/fimgs/b23163cb092342b6_8573-w800-h600-b0-p0---.jpg',
    label: 'Grand Rapids Residence',
  },
  {
    src: 'https://st.hzcdn.com/fimgs/e46143b906a13316_0407-w800-h600-b0-p0---.jpg',
    label: 'Lakefront Home',
  },
  {
    src: 'https://st.hzcdn.com/fimgs/2b9157e3044197c4_0278-w800-h600-b0-p0---patio.jpg',
    label: 'Saint Thomas Outdoor Dining',
  },
  {
    src: 'https://st.hzcdn.com/fimgs/3c4170670873f84a_0403-w800-h600-b0-p0---.jpg',
    label: 'Custom Furniture Design',
  },
];

export default function ReviewsPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />

      {/* Hero */}
      <section className="relative h-[65vh] min-h-[480px] overflow-hidden">
        <img
          src="https://st.hzcdn.com/fimgs/dba1581b04419809_0405-w800-h600-b0-p0---patio.jpg"
          alt="K LINN Interiors project"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          <div className="flex items-center justify-center gap-2 mb-6">
            {[...Array(5)].map((_, i) => (
              <i key={i} className="ri-star-fill text-3xl text-amber-400"></i>
            ))}
          </div>
          <h1 className="font-['Cormorant_Garamond'] text-5xl md:text-7xl font-light text-white mb-4">
            33 Five-Star Reviews
          </h1>
          <div className="w-16 h-px bg-amber-400 mb-6"></div>
          <p className="font-['Montserrat'] text-white/80 text-lg max-w-xl leading-relaxed">
            Trusted by homeowners across Michigan, Grand Rapids, and Saint Thomas.
          </p>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="bg-gray-900 py-10 px-6">
        <div className="max-w-5xl mx-auto grid grid-cols-3 gap-8 text-center">
          <div>
            <p className="font-['Cormorant_Garamond'] text-5xl font-light text-amber-400">33</p>
            <p className="font-['Montserrat'] text-white/60 text-sm tracking-widest uppercase mt-1">Five-Star Reviews</p>
          </div>
          <div>
            <p className="font-['Cormorant_Garamond'] text-5xl font-light text-amber-400">15+</p>
            <p className="font-['Montserrat'] text-white/60 text-sm tracking-widest uppercase mt-1">Years of Experience</p>
          </div>
          <div>
            <p className="font-['Cormorant_Garamond'] text-5xl font-light text-amber-400">Best</p>
            <p className="font-['Montserrat'] text-white/60 text-sm tracking-widest uppercase mt-1">of Houzz Award</p>
          </div>
        </div>
      </section>

      {/* Featured Reviews */}
      <section className="py-24 px-6 bg-amber-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="font-['Montserrat'] text-amber-600 tracking-[0.3em] text-sm uppercase mb-3">Client Stories</p>
            <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light text-gray-900">
              Featured Testimonials
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {featuredReviews.map((review, index) => (
              <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md group">
                <div className="h-56 overflow-hidden">
                  <img
                    src={projectImages[index].src}
                    alt={projectImages[index].label}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-8">
                  <div className="flex items-center gap-1 mb-4">
                    {[...Array(review.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-lg text-amber-500"></i>
                    ))}
                  </div>
                  <p className="font-['Montserrat'] text-gray-700 leading-relaxed mb-6 italic text-sm">
                    "{review.text}"
                  </p>
                  <div className="border-t border-gray-100 pt-4 flex items-center justify-between">
                    <div>
                      <p className="font-['Montserrat'] font-semibold text-gray-900 text-sm">{review.name}</p>
                      <p className="font-['Montserrat'] text-xs text-gray-400">{review.date}</p>
                    </div>
                    <span className="text-xs font-['Montserrat'] text-amber-600 bg-amber-50 px-3 py-1 rounded-full whitespace-nowrap">
                      {review.project}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Project Photo Grid */}
      <section className="py-0">
        <div className="grid grid-cols-3 md:grid-cols-6 h-48 md:h-64">
          {projectImages.map((img, i) => (
            <div key={i} className="relative overflow-hidden group cursor-pointer">
              <img
                src={img.src}
                alt={img.label}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-500 flex items-end p-3">
                <p className="font-['Montserrat'] text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {img.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* All Reviews */}
      <section className="py-24 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <p className="font-['Montserrat'] text-amber-600 tracking-[0.3em] text-sm uppercase mb-3">More Voices</p>
            <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light text-gray-900">
              What Our Clients Say
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-x-16 gap-y-10">
            {allReviews.map((review, index) => (
              <div key={index} className="border-l-2 border-amber-200 pl-6 hover:border-amber-500 transition-colors duration-300">
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(review.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm text-amber-500"></i>
                  ))}
                </div>
                <p className="font-['Montserrat'] text-gray-700 leading-relaxed text-sm mb-4 italic">
                  "{review.text}"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center">
                    <i className="ri-user-line text-amber-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="font-['Montserrat'] font-semibold text-gray-900 text-sm">{review.name}</p>
                    <p className="font-['Montserrat'] text-xs text-gray-400">{review.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Houzz CTA Banner */}
      <section className="relative py-28 px-6 overflow-hidden">
        <img
          src="https://st.hzcdn.com/fimgs/7941fcaf044197d4_9672-w800-h600-b0-p0---bathroom.jpg"
          alt="K LINN Interiors"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/65"></div>
        <div className="relative max-w-4xl mx-auto text-center">
          <p className="font-['Montserrat'] text-amber-400 tracking-[0.3em] text-sm uppercase mb-4">Verified Reviews</p>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light text-white mb-6">
            See All Reviews on Houzz
          </h2>
          <p className="font-['Montserrat'] text-white/70 text-lg mb-10 max-w-xl mx-auto">
            Browse our full portfolio and all 33 verified five-star client reviews on our Houzz profile.
          </p>
          <a
            href="https://www.houzz.com/professionals/interior-designers-and-decorators/k-linn-interiors-pfvwus-pf~2115352616"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-3 bg-amber-500 text-white font-['Montserrat'] text-sm font-medium tracking-widest uppercase px-10 py-4 hover:bg-amber-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line text-lg"></i>
            View on Houzz
          </a>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light text-gray-900 mb-6">
            Ready to Start Your Project?
          </h2>
          <p className="font-['Montserrat'] text-gray-600 text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
            Join our satisfied clients and let us transform your space into something extraordinary.
          </p>
          <a
            href="/contact"
            className="inline-block bg-gray-900 text-white font-['Montserrat'] text-sm font-medium tracking-widest uppercase px-10 py-4 hover:bg-amber-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            Get In Touch
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
